import { api } from './_request';

export const get = () => {
	return (dispatch) => {

		api().get('/departamentos_tabla')
		.then(function(response)
		{
			if(response.status === 200)
			{
				dispatch({
					type: 'OLDTICKETS_LIST',
					payload: response.data
				});
			}
		});

	}
}

export const update = (departamento, callback) => {
	return (dispatch) => {

        console.log(departamento);
		dispatch({ type: 'PROSPECT_SAVE' });

		api().post(`departamento/${departamento.id}`, departamento)
		.then(function(response)
		{
			if(response.status === 200)
			{
				dispatch({
					type: 'PROSPECT_UPDATE_SUCCESS',
					payload: response.data
				});

				if(typeof callback === 'function') callback();
			}
			else
			{
				dispatch({ type: 'PROSPECT_SAVE_FAILURE' });
			}
		})
		.catch(function(error) {
			dispatch({ type: 'PROSPECT_SAVE_FAILURE' });
		});

	}
}


// WEBPACK FOOTER //
// ./src/actions/departamentos.js